import { render, staticRenderFns } from "./NewsAlerts.vue?vue&type=template&id=7d1f0729&scoped=true"
import script from "./NewsAlerts.vue?vue&type=script&lang=js"
export * from "./NewsAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1f0729",
  null
  
)

export default component.exports